






















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import { DynamicPartsTalkText } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppAvatar,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsTalkText>,
      required: true,
    },
  },
  setup() {
    /**
     * 本文のテキストのスタイル
     * @see https://team-lab.backlog.com/view/ENOTECA_ALL-13883
     * 右寄せは廃止されたが、DBの関係で既存の記事はstyleではなくlayoutが返ってくる
     */
    const bodyTextClass = (user: DynamicPartsTalkText['talk_text'][number]): string => {
      const { style, layout } = user;
      if (style === 'bold' || layout === 'left') {
        return 'font-bold text-base';
      }
      return 'font-normal text-lg md:text-base';
    };

    return { bodyTextClass };
  },
});
